<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">評估列表</h1>
        <p class="page-subtitle">管理不同年級的中文/英文評估內容，支援編輯和查看詳情</p>
      </div>
      <div class="header-right">
        <!-- 可扩展添加批量操作/导入等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%;"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無評估數據' : ''"
          >
            <el-table-column label="#" type="index" width="60"> </el-table-column>
            <el-table-column
                prop="gradeName"
                label="年級"
                align="center"
                min-width="100"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <el-tag size="mini" type="info">{{ row.gradeName || '-' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="中文" width="200" align="center">
              <template slot-scope="{ row }">
                <div class="operation-group">
                  <el-button
                      type="text"
                      size="small"
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click="onEditButton(setRow(row.assessments, 0))"
                      icon="el-icon-edit"
                      class="edit-btn"
                  >
                    編輯
                  </el-button>
                  <el-button
                      type="text"
                      size="small"
                      @click="onDetailButton(setRow(row.assessments, 0))"
                      icon="el-icon-view"
                      class="detail-btn"
                  >
                    詳情
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="ENG" width="200" align="center">
              <template slot-scope="{ row }">
                <div class="operation-group">
                  <el-button
                      type="text"
                      size="small"
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click="onEditButton(setRow(row.assessments, 1))"
                      icon="el-icon-edit"
                      class="edit-btn"
                  >
                    編輯
                  </el-button>
                  <el-button
                      type="text"
                      size="small"
                      @click="onDetailButton(setRow(row.assessments, 1))"
                      icon="el-icon-view"
                      class="detail-btn"
                  >
                    詳情
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="assessment-card" v-for="(row, index) in tableData" :key="row.id || index">
            <!-- 卡片头部：年级 -->
            <div class="card-header">
              <el-tag size="medium" type="info" class="grade-tag">
                {{ row.gradeName || '未知年級' }}
              </el-tag>
            </div>

            <!-- 卡片主体 -->
            <div class="card-body">
              <!-- 中文评估 -->
              <div class="lang-section">
                <div class="lang-title">
                  <i class="el-icon-chat-line-round"></i>
                  中文評估
                </div>
                <div class="lang-actions">
                  <el-button
                      type="text"
                      size="mini"
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click="onEditButton(setRow(row.assessments, 0))"
                      icon="el-icon-edit"
                      class="edit-btn"
                  >
                    編輯
                  </el-button>
                  <el-button
                      type="text"
                      size="mini"
                      @click="onDetailButton(setRow(row.assessments, 0))"
                      icon="el-icon-view"
                      class="detail-btn"
                  >
                    詳情
                  </el-button>
                </div>
              </div>

              <!-- 英文评估 -->
              <div class="lang-section">
                <div class="lang-title">
                  <i class="el-icon-chat-dot-round"></i>
                  ENG評估
                </div>
                <div class="lang-actions">
                  <el-button
                      type="text"
                      size="mini"
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click="onEditButton(setRow(row.assessments, 1))"
                      icon="el-icon-edit"
                      class="edit-btn"
                  >
                    編輯
                  </el-button>
                  <el-button
                      type="text"
                      size="mini"
                      @click="onDetailButton(setRow(row.assessments, 1))"
                      icon="el-icon-view"
                      class="detail-btn"
                  >
                    詳情
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            <i class="el-icon-document-empty"></i>
            <p>暫無評估數據</p>
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container" v-show="total > 0">
        <Pagination
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getAssessments"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getAssessments } from "@/api/assessment";

export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      // 补充角色ID变量（根据实际业务调整）
      adminUserInfoRoleId: this.$store.getters.adminUserInfo?.roleId || '',
      teacherRoleId: 'teacher', // 根据实际业务调整
      formLabelAlign: {
        orderNoLike: null,
        orderDate: null,
        userNo: null,
        status: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getAssessments();
  },
  methods: {
    // 路由跳转方法补充
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 下划线转换（补充实现）
    underline(str) {
      // 驼峰转下划线
      return str.replace(/([A-Z])/g, '_$1').toLowerCase();
    },
    // 设置行数据
    setRow(row, lang) {
      try {
        const filteredRow = row?.filter((v) => v.lang == lang)[0];
        return filteredRow?.id || '';
      } catch (error) {
        console.error('获取评估ID失败：', error);
        return '';
      }
    },
    // 排序处理
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = this.underline(column.prop) + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = this.underline(column.prop) + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getAssessments();
    },
    // 重置筛选
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key == '_page') {
          this.formLabelAlign[key] = 1;
        }
        if (key == '_limit') {
          this.formLabelAlign[key] = 10; // 恢复默认10条/页
        }
      });
      this.getAssessments();
      this.$message.info("篩選條件已重置");
    },
    // 搜索
    onSearch() {
      this.formLabelAlign._page = 1; // 搜索时重置页码
      this.getAssessments();
    },
    // 取消对话框
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 编辑按钮
    onEditButton(id) {
      if (!id) {
        this.$message.warning("評估ID不存在，無法編輯");
        return;
      }
      let path = `/evaluate/${id}/edit`;
      this.resolveRouter(path);
    },
    // 详情按钮
    onDetailButton(id) {
      if (!id) {
        this.$message.warning("評估ID不存在，無法查看詳情");
        return;
      }
      let path = `/evaluate/${id}`;
      this.resolveRouter(path);
    },
    // 修改按钮
    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    // 获取评估列表
    getAssessments() {
      let formLabelAlign = {
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };

      // 加载中提示
      const loading = this.$loading({
        lock: true,
        text: '加載評估數據中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      getAssessments(formLabelAlign)
          .then((v) => {
            this.tableData = v.data || [];
            this.total = Number(v.headers["x-total-count"]) || 0;
          })
          .catch(err => {
            this.$message.error("獲取評估列表失敗，請稍後重試");
            console.error('获取评估数据失败：', err);
            this.tableData = [];
            this.total = 0;
          })
          .finally(() => {
            loading.close();
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 数据容器样式 */
.data-container {
  width: 100%;
  margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      .operation-group {
        display: flex;
        justify-content: center;
        gap: 8px;
      }

      .edit-btn {
        color: #409eff;
      }

      .detail-btn {
        color: #166ea5;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 评估卡片 */
    .assessment-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.2s ease;

      &:hover {
        border-color: #166ea5;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      /* 卡片头部 */
      .card-header {
        margin-bottom: 16px;
        text-align: center;

        .grade-tag {
          font-size: 16px;
          padding: 4px 16px;
        }
      }

      /* 卡片主体 */
      .card-body {
        .lang-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 8px;
          border-bottom: 1px solid #e9ecef;

          &:last-child {
            border-bottom: none;
          }

          .lang-title {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 16px;
            font-weight: 500;
            color: #1f2937;

            i {
              color: #166ea5;
            }
          }

          .lang-actions {
            display: flex;
            gap: 8px;
          }
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }
}

/* 分页容器 */
.pagination-container {
  text-align: right;
  padding: 10px 0;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }
  .data-container .mobile-cards {
    display: flex;
  }

  /* 分页适配 */
  .pagination-container {
    text-align: center;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    padding: 20px;
  }
}
</style>